export const createFileFingerprint = (fileName: string, size: number): string =>
    btoa(`${fileName}-${size}`).replace(/\+/g, "-").replace(/\//g, "_").replace(/=/g, "")

export const trimBase64Padding = (base64: string): string => base64.replace(/=+$/, "")

export function createIdFromFile(
    file: File | { name: string; size: number; lastModified: number }
) {
    const fileparts = "name" in file ? file.name?.split(".") : [""]
    return `${fileparts.slice(0, -1).join(".")}.${"size" in file ? file.size : 0}.${Date.now()}.${fileparts.at(-1)}`
}

/**
 * Returns tuple of file name and extension.
 *
 * @example
 * Input: "perimeter.123.kml"
 * Output: [ "perimeter.123", "kml" ]
 */
export const splitExtension = (fileName: string): [string, string | undefined] => {
    const split = fileName.split(".")
    if (split.length <= 1) return [fileName, undefined]

    const extension = split.at(-1)!

    return [split.slice(0, -1).join("."), extension]
}
